import React, { Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as recordDetailActions from '../recordDetail/reducer';
import { TYPE } from '../utility/types';
import FilterControl from '../filter/FilterControl';
import Search from '../search/Search';
import { getBaseUrl } from '../utility/service';

import icons from '../assets/icons';
import './HomeCommands.css';

import {msalConfig} from '../provider/authConfig';
import service from '../utility/service';

export class HomeCommandsComponent extends Component {
  static get propTypes() {
    return {
      type: PropTypes.oneOf([''].concat(TYPE.values)),
      onNewRecord: PropTypes.func.isRequired,
    };
  }

  render() {
    const { onNewRecord, fetching, appInitialised } = this.props;     // extract fetching from this.props. this.props holds properties passed to this component by its parent
    const type = this.props.match.params.type;

    return (<div className="Home-commands">
      <div className="Home-commands-group">
        <FilterControl type={type} />
        <Search />
      </div>

      <div className="Home-commands-group">
        <button className="btn export-excel" onClick={() => onExcelExport(type, msalConfig)}>
          <img alt="Edit" src={icons.excelExport} /><span>Export</span>
        </button>  
      </div>

      <div className="Home-commands-group">
        <button className="btn btn-primary new-order" onClick={() => onNewRecord()}  disabled={fetching || !appInitialised}>
          <img alt="Edit" src={icons.white.add} /><span>New {type}</span>
        </button>
      </div>
    </div>);
  }
}


function onExcelExport(type, msalConfig) {
  let exportUrl = `${getBaseUrl()}/ExcelExports/${type}s`;

  let config = {
    method: 'get',
    url: exportUrl,
    responseType: 'blob',
    headers: {
      'Authorization': `Bearer ${msalConfig.lastToken}`
    }
  };

  service(config)
    .then(function (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${type}s.csv`);
      document.body.appendChild(link);
      link.click();
    })
    .catch(function (error) {
      console.log(error);
  });

  return;
}


const mapStateToProps = state => ({
  type: state.recordList.type,  
  filterKey: state.recordList.filterKey,
  fetching: state.recordList.fetching ,    ///PBI 8375092
  appInitialised: state.recordList.appInitialised    ///PBI 8375092
});

const mapDispatchToProps = (dispatch) => {
  const {
    newRecord,
  } = bindActionCreators(recordDetailActions, dispatch);

  return {
    onNewRecord: newRecord,
  };
};

const HomeCommands = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeCommandsComponent));
export default HomeCommands;



// WEBPACK FOOTER //
// ./src/home/HomeCommands.js